"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toESM = function __toESM(mod, isNodeMode, target) {
  return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
    value: mod,
    enumerable: true
  }) : target, mod);
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};

// packages/react/slot/src/index.ts
var src_exports = {};
__export(src_exports, {
  Root: function Root() {
    return _Root;
  },
  Slot: function Slot() {
    return _Slot;
  },
  Slottable: function Slottable() {
    return _Slottable;
  }
});
module.exports = __toCommonJS(src_exports);

// packages/react/slot/src/Slot.tsx
var React = __toESM(require("react"));
var import_react_compose_refs = require("@radix-ui/react-compose-refs");
var import_jsx_runtime = require("react/jsx-runtime");
var _Slot = React.forwardRef(function (props, forwardedRef) {
  var children = props.children,
    slotProps = _objectWithoutProperties(props, ["children"]);
  var childrenArray = React.Children.toArray(children);
  var slottable = childrenArray.find(isSlottable);
  if (slottable) {
    var newElement = slottable.props.children;
    var newChildren = childrenArray.map(function (child) {
      if (child === slottable) {
        if (React.Children.count(newElement) > 1) return React.Children.only(null);
        return React.isValidElement(newElement) ? newElement.props.children : null;
      } else {
        return child;
      }
    });
    return /* @__PURE__ */(0, import_jsx_runtime.jsx)(SlotClone, _objectSpread({}, slotProps, {
      ref: forwardedRef,
      children: React.isValidElement(newElement) ? React.cloneElement(newElement, void 0, newChildren) : null
    }));
  }
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(SlotClone, _objectSpread({}, slotProps, {
    ref: forwardedRef,
    children: children
  }));
});
_Slot.displayName = "Slot";
var SlotClone = React.forwardRef(function (props, forwardedRef) {
  var children = props.children,
    slotProps = _objectWithoutProperties(props, ["children"]);
  if (React.isValidElement(children)) {
    var childrenRef = getElementRef(children);
    return React.cloneElement(children, _objectSpread({}, mergeProps(slotProps, children.props), {
      // @ts-ignore
      ref: forwardedRef ? (0, import_react_compose_refs.composeRefs)(forwardedRef, childrenRef) : childrenRef
    }));
  }
  return React.Children.count(children) > 1 ? React.Children.only(null) : null;
});
SlotClone.displayName = "SlotClone";
var _Slottable = function _Slottable(_ref) {
  var children = _ref.children;
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
    children: children
  });
};
function isSlottable(child) {
  return React.isValidElement(child) && child.type === _Slottable;
}
function mergeProps(slotProps, childProps) {
  var overrideProps = _objectSpread({}, childProps);
  var _loop2 = function _loop2() {
    var slotPropValue = slotProps[propName];
    var childPropValue = childProps[propName];
    var isHandler = /^on[A-Z]/.test(propName);
    if (isHandler) {
      if (slotPropValue && childPropValue) {
        overrideProps[propName] = function () {
          childPropValue.apply(void 0, arguments);
          slotPropValue.apply(void 0, arguments);
        };
      } else if (slotPropValue) {
        overrideProps[propName] = slotPropValue;
      }
    } else if (propName === "style") {
      overrideProps[propName] = _objectSpread({}, slotPropValue, childPropValue);
    } else if (propName === "className") {
      overrideProps[propName] = [slotPropValue, childPropValue].filter(Boolean).join(" ");
    }
  };
  for (var propName in childProps) {
    _loop2();
  }
  return _objectSpread({}, slotProps, overrideProps);
}
function getElementRef(element) {
  var getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
  var mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.ref;
  }
  getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
  mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.props.ref;
  }
  return element.props.ref || element.ref;
}
var _Root = _Slot;